import { render, staticRenderFns } from "./LoaderBarra.vue?vue&type=template&id=b6b1b30e&scoped=true&"
import script from "./LoaderBarra.vue?vue&type=script&lang=js&"
export * from "./LoaderBarra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b1b30e",
  null
  
)

export default component.exports